import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';

function initISFeedCarousel() {
  const wrapper = document.querySelector('.investment-solutions-feed');
  if (!wrapper) return;

  const carousel = wrapper.querySelector('.is-feed-carousel');
  if (!carousel) return;

  const swiperWrapper = carousel.querySelector('.swiper-wrapper');
  if (!swiperWrapper) return;

  const swiperEl = carousel.querySelector('.swiper');
  if (!swiperEl) return;

  const btnNext = wrapper.querySelector('.swiper-button-next');
  const btnPrev = wrapper.querySelector('.swiper-button-prev');

  try {
    const swiper = new Swiper(swiperEl, {
      spaceBetween: 16,
      modules: [Navigation],
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },
      loop: false,
      slidesPerView: 'auto',
      on: {
        init: (swiper) => {
          updateControlsVisibility(wrapper, swiper);
          updateButtonStates(btnPrev, btnNext, swiper);
        },
        slideChange: (swiper) => {
          updateButtonStates(btnPrev, btnNext, swiper);
        },
        lock: (swiper) => {
          updateControlsVisibility(wrapper, swiper);
        },
        unlock: (swiper) => {
          updateControlsVisibility(wrapper, swiper);
        },
      },
    });
  } catch (error) {
    console.error('Failed to initialize IS feed carousel:', error);
  }
}

function updateControlsVisibility(el, swiper) {
  const controls = el.querySelector('.swiper-controls');
  if (controls) {
    controls.style.display = swiper.isLocked ? 'none' : '';
    controls.style.opacity = swiper.isLocked ? '0' : '1';
  }
}

function updateButtonStates(btnPrev, btnNext, swiper) {
  if (btnPrev) {
    btnPrev.classList.toggle('swiper-button-disabled', swiper.isBeginning);
    btnPrev.disabled = swiper.isBeginning;
  }
  if (btnNext) {
    btnNext.classList.toggle('swiper-button-disabled', swiper.isEnd);
    btnNext.disabled = swiper.isEnd;
  }
}

window.addEventListener('DOMContentLoaded', initISFeedCarousel);
